
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.02.008c-.404-.05-.819.14-1.035.514L9.979.53C8.145.021 6.135.925 5.18 2.573c0 0-2.612 4.526-4.438 4.22-.02.002-.038.017-.06.019a.762.762 0 00-.238.073c-.03.015-.06.025-.088.043a.767.767 0 00-.251.257.78.78 0 00.286 1.07l9.501 5.485a.782.782 0 001.072-.286.771.771 0 00.095-.347c.003-.032-.006-.063-.008-.096a.75.75 0 00-.053-.245c-.008-.019-.005-.04-.014-.059-1.178-1.428 1.435-5.955 1.435-5.955.95-1.65.728-3.843-.631-5.177l.006-.008a1.047 1.047 0 00-.775-1.56zM1.33 9.967c-.15.727.083 1.51.692 2.022.8.67 1.95.633 2.712-.035l-3.253-1.877c-.063-.037-.093-.073-.15-.11z","fill":"#007F32"}})])
          )
        }
      }
    